// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════
   VideoPlayer.css — Forge Retreat cinematic full-screen player
══════════════════════════════════════════════════════════════ */

/* ── Container — covers the entire viewport, always on top ── */
.vp {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Fallback if native fullscreen is blocked */
  width: 100vw;
  height: 100dvh;
}

/* ── Video fills the container, letterboxed ── */
.vp__video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  /* No pointer events — handled by overlay */
  pointer-events: none;
}

/* ── Transparent click-to-play layer (sits above video, below controls) ── */
.vp__click-area {
  position: absolute;
  inset: 0;
  cursor: pointer;
  /* Top and bottom reserved for controls */
  top: 72px;
  bottom: 100px;
}

/* ══ Controls overlay ══════════════════════════════════════ */
.vp__controls {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
  /* Cinematic gradient vignette so controls read over any content */
  background:
    linear-gradient(to bottom,
      rgba(0,0,0,0.72) 0%,
      rgba(0,0,0,0) 22%,
      rgba(0,0,0,0) 60%,
      rgba(0,0,0,0.8) 100%);
}
/* All children of controls are clickable */
.vp__controls > * { pointer-events: all; }

/* ── Top bar ── */
.vp__top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(1rem, 2.5vw, 1.75rem) clamp(1rem, 3vw, 2.5rem);
}

/* Back button */
.vp__back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255,255,255,0.12);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 99px;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.5rem 1.1rem 0.5rem 0.8rem;
  cursor: pointer;
  transition:
    background 0.2s,
    transform 0.15s;
}
.vp__back-btn:hover {
  background: rgba(255,255,255,0.22);
  transform: translateX(-2px);
}
.vp__back-icon {
  font-size: 1rem;
  flex-shrink: 0;
}

/* Film title */
.vp__title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.1rem;
}
.vp__title-eyebrow {
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.5);
}
.vp__title-name {
  font-family: var(--font-serif, Georgia, serif);
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(255,255,255,0.9);
}

/* ── Centre big play/pause ── */
.vp__centre-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: clamp(4rem, 8vw, 5.5rem);
  height: clamp(4rem, 8vw, 5.5rem);
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 2px solid rgba(255,255,255,0.4);
  color: #fff;
  font-size: clamp(1.1rem, 2.5vw, 1.6rem);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, transform 0.15s;
  padding-left: 3px; /* optical centering for play triangle */
  pointer-events: all;
}
.vp__centre-play:hover {
  background: rgba(255,255,255,0.28);
  transform: translate(-50%, -50%) scale(1.06);
}

/* ── Bottom bar ── */
.vp__bottom-bar {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0 clamp(1rem, 3vw, 2.5rem) clamp(1rem, 2.5vw, 1.75rem);
}

/* Scrubber */
.vp__scrubber {
  cursor: pointer;
  padding: 0.75rem 0; /* bigger hit area */
  margin: 0 -0.25rem;
}
.vp__scrubber-track {
  position: relative;
  height: 3px;
  background: rgba(255,255,255,0.2);
  border-radius: 99px;
  overflow: visible;
  transition: height 0.15s;
}
.vp__scrubber:hover .vp__scrubber-track { height: 5px; }

.vp__scrubber-buffered {
  position: absolute;
  left: 0; top: 0; bottom: 0;
  background: rgba(255,255,255,0.3);
  border-radius: 99px;
  transition: width 0.3s linear;
}
.vp__scrubber-played {
  position: absolute;
  left: 0; top: 0; bottom: 0;
  background: #b85c38; /* Forge rust */
  border-radius: 99px;
  transition: width 0.05s linear;
}
.vp__scrubber-thumb {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(184,92,56,0.5);
  opacity: 0;
  transition: opacity 0.15s, transform 0.15s;
  pointer-events: none;
}
.vp__scrubber:hover .vp__scrubber-thumb { opacity: 1; }

/* Controls row */
.vp__controls-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.vp__controls-left,
.vp__controls-right {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.vp__ctrl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background: none;
  border: none;
  color: rgba(255,255,255,0.85);
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.vp__ctrl-btn:hover {
  background: rgba(255,255,255,0.12);
  color: #fff;
}

.vp__time {
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(255,255,255,0.7);
  letter-spacing: 0.05em;
  margin-left: 0.35rem;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

/* ══ Mobile / Tablet ══════════════════════════════════════ */
@media (max-width: 1023px) {
  /* Slightly bigger controls for touch */
  .vp__ctrl-btn  { width: 2.8rem; height: 2.8rem; font-size: 1rem; }
  .vp__scrubber  { padding: 1rem 0; }
  .vp__scrubber-track { height: 4px; }
  .vp__scrubber:hover .vp__scrubber-track { height: 6px; }
  .vp__scrubber-thumb { width: 16px; height: 16px; opacity: 1; } /* always visible on touch */
  .vp__time      { font-size: 0.7rem; }
  .vp__centre-play { width: clamp(4rem, 12vw, 5rem); height: clamp(4rem, 12vw, 5rem); }
}

/* Landscape hint bar for phones that don't support orientation lock */
@media (max-width: 767px) and (orientation: portrait) {
  .vp::after {
    content: "⟳  Rotate for best experience";
    position: absolute;
    bottom: 7.5rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.45);
    pointer-events: none;
    white-space: nowrap;
  }
}

/* ══ Reduced motion ════════════════════════════════════════ */
@media (prefers-reduced-motion: reduce) {
  .vp__back-btn,
  .vp__centre-play { transition: none; }
}

/* ══ Gesture gate — URL-triggered open, needs one tap ═════ */
.vp__gesture-gate {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* Subtle cinematic gradient so it feels intentional, not broken */
  background: linear-gradient(
    135deg,
    rgba(27,27,27,0.92) 0%,
    rgba(30,42,30,0.88) 100%
  );
  z-index: 10;
}

.vp__gesture-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  text-align: center;
  pointer-events: none; /* clicks pass through to the gate */
}

/* Pulsing play ring */
.vp__gesture-ring {
  width: clamp(5rem, 10vw, 7rem);
  height: clamp(5rem, 10vw, 7rem);
  border-radius: 50%;
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 2px solid rgba(255,255,255,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: vp-pulse 2.4s ease-in-out infinite;
}
.vp__gesture-icon {
  font-size: clamp(1.5rem, 3vw, 2.2rem);
  color: #fff;
  padding-left: 4px; /* optical centering */
}

@keyframes vp-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(255,255,255,0.25); }
  50%       { box-shadow: 0 0 0 18px rgba(255,255,255,0); }
}

.vp__gesture-label {
  font-size: clamp(0.78rem, 1.8vw, 1rem);
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.8);
  margin: 0;
}

/* Back link — pointer-events re-enabled so it's clickable */
.vp__gesture-back {
  pointer-events: all;
  background: none;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 99px;
  color: rgba(255,255,255,0.45);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 0.4rem 1rem;
  cursor: pointer;
  transition: all 0.18s;
}
.vp__gesture-back:hover {
  border-color: rgba(255,255,255,0.45);
  color: rgba(255,255,255,0.8);
}

@media (max-width: 767px) {
  .vp__gesture-label { letter-spacing: 0.08em; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/VideoPlayer.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,YAAY;EACZ,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,yCAAyC;EACzC,SAAS;EACT,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,kEAAkE;EAClE;;;;;2BAKyB;AAC3B;AACA,2CAA2C;AAC3C,oBAAoB,mBAAmB,EAAE;;AAEzC,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf;;mBAEiB;AACnB;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;EACvC,WAAW;EACX,uCAAuC;EACvC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,iBAAiB,EAAE,wCAAwC;EAC3D,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,+DAA+D;AACjE;;AAEA,aAAa;AACb;EACE,eAAe;EACf,kBAAkB,EAAE,oBAAoB;EACxC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA,0CAA0C,WAAW,EAAE;;AAEvD;EACE,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,mBAAmB,EAAE,eAAe;EACpC,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,UAAU;EACV,0CAA0C;EAC1C,oBAAoB;AACtB;AACA,0CAA0C,UAAU,EAAE;;AAEtD,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,uCAAuC;EACvC,iBAAiB,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;EACjE,iBAAiB,eAAe,EAAE;EAClC,sBAAsB,WAAW,EAAE;EACnC,0CAA0C,WAAW,EAAE;EACvD,sBAAsB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,EAAE,4BAA4B;EAC3F,iBAAiB,iBAAiB,EAAE;EACpC,mBAAmB,8BAA8B,EAAE,+BAA+B,EAAE;AACtF;;AAEA,sEAAsE;AACtE;EACE;IACE,wCAAwC;IACxC,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA,+DAA+D;AAC/D;EACE;qBACmB,gBAAgB,EAAE;AACvC;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kEAAkE;EAClE;;;;GAIC;EACD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB,EAAE,oCAAoC;AAC5D;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;AACA;EACE,qCAAqC;EACrC,WAAW;EACX,iBAAiB,EAAE,sBAAsB;AAC3C;;AAEA;EACE,WAAW,0CAA0C,EAAE;EACvD,YAAY,0CAA0C,EAAE;AAC1D;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,SAAS;AACX;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB,sBAAsB,EAAE;AAC/C","sourcesContent":["/* ══════════════════════════════════════════════════════════════\n   VideoPlayer.css — Forge Retreat cinematic full-screen player\n══════════════════════════════════════════════════════════════ */\n\n/* ── Container — covers the entire viewport, always on top ── */\n.vp {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Fallback if native fullscreen is blocked */\n  width: 100vw;\n  height: 100dvh;\n}\n\n/* ── Video fills the container, letterboxed ── */\n.vp__video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  /* No pointer events — handled by overlay */\n  pointer-events: none;\n}\n\n/* ── Transparent click-to-play layer (sits above video, below controls) ── */\n.vp__click-area {\n  position: absolute;\n  inset: 0;\n  cursor: pointer;\n  /* Top and bottom reserved for controls */\n  top: 72px;\n  bottom: 100px;\n}\n\n/* ══ Controls overlay ══════════════════════════════════════ */\n.vp__controls {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  pointer-events: none;\n  /* Cinematic gradient vignette so controls read over any content */\n  background:\n    linear-gradient(to bottom,\n      rgba(0,0,0,0.72) 0%,\n      rgba(0,0,0,0) 22%,\n      rgba(0,0,0,0) 60%,\n      rgba(0,0,0,0.8) 100%);\n}\n/* All children of controls are clickable */\n.vp__controls > * { pointer-events: all; }\n\n/* ── Top bar ── */\n.vp__top-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: clamp(1rem, 2.5vw, 1.75rem) clamp(1rem, 3vw, 2.5rem);\n}\n\n/* Back button */\n.vp__back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255,255,255,0.12);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(255,255,255,0.18);\n  border-radius: 99px;\n  color: #fff;\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 0.5rem 1.1rem 0.5rem 0.8rem;\n  cursor: pointer;\n  transition:\n    background 0.2s,\n    transform 0.15s;\n}\n.vp__back-btn:hover {\n  background: rgba(255,255,255,0.22);\n  transform: translateX(-2px);\n}\n.vp__back-icon {\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n/* Film title */\n.vp__title {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.1rem;\n}\n.vp__title-eyebrow {\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.5);\n}\n.vp__title-name {\n  font-family: var(--font-serif, Georgia, serif);\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: rgba(255,255,255,0.9);\n}\n\n/* ── Centre big play/pause ── */\n.vp__centre-play {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: clamp(4rem, 8vw, 5.5rem);\n  height: clamp(4rem, 8vw, 5.5rem);\n  border-radius: 50%;\n  background: rgba(255,255,255,0.15);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 2px solid rgba(255,255,255,0.4);\n  color: #fff;\n  font-size: clamp(1.1rem, 2.5vw, 1.6rem);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s, transform 0.15s;\n  padding-left: 3px; /* optical centering for play triangle */\n  pointer-events: all;\n}\n.vp__centre-play:hover {\n  background: rgba(255,255,255,0.28);\n  transform: translate(-50%, -50%) scale(1.06);\n}\n\n/* ── Bottom bar ── */\n.vp__bottom-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0 clamp(1rem, 3vw, 2.5rem) clamp(1rem, 2.5vw, 1.75rem);\n}\n\n/* Scrubber */\n.vp__scrubber {\n  cursor: pointer;\n  padding: 0.75rem 0; /* bigger hit area */\n  margin: 0 -0.25rem;\n}\n.vp__scrubber-track {\n  position: relative;\n  height: 3px;\n  background: rgba(255,255,255,0.2);\n  border-radius: 99px;\n  overflow: visible;\n  transition: height 0.15s;\n}\n.vp__scrubber:hover .vp__scrubber-track { height: 5px; }\n\n.vp__scrubber-buffered {\n  position: absolute;\n  left: 0; top: 0; bottom: 0;\n  background: rgba(255,255,255,0.3);\n  border-radius: 99px;\n  transition: width 0.3s linear;\n}\n.vp__scrubber-played {\n  position: absolute;\n  left: 0; top: 0; bottom: 0;\n  background: #b85c38; /* Forge rust */\n  border-radius: 99px;\n  transition: width 0.05s linear;\n}\n.vp__scrubber-thumb {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 0 0 2px rgba(184,92,56,0.5);\n  opacity: 0;\n  transition: opacity 0.15s, transform 0.15s;\n  pointer-events: none;\n}\n.vp__scrubber:hover .vp__scrubber-thumb { opacity: 1; }\n\n/* Controls row */\n.vp__controls-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.vp__controls-left,\n.vp__controls-right {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.vp__ctrl-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  background: none;\n  border: none;\n  color: rgba(255,255,255,0.85);\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n.vp__ctrl-btn:hover {\n  background: rgba(255,255,255,0.12);\n  color: #fff;\n}\n\n.vp__time {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: rgba(255,255,255,0.7);\n  letter-spacing: 0.05em;\n  margin-left: 0.35rem;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  user-select: none;\n}\n\n/* ══ Mobile / Tablet ══════════════════════════════════════ */\n@media (max-width: 1023px) {\n  /* Slightly bigger controls for touch */\n  .vp__ctrl-btn  { width: 2.8rem; height: 2.8rem; font-size: 1rem; }\n  .vp__scrubber  { padding: 1rem 0; }\n  .vp__scrubber-track { height: 4px; }\n  .vp__scrubber:hover .vp__scrubber-track { height: 6px; }\n  .vp__scrubber-thumb { width: 16px; height: 16px; opacity: 1; } /* always visible on touch */\n  .vp__time      { font-size: 0.7rem; }\n  .vp__centre-play { width: clamp(4rem, 12vw, 5rem); height: clamp(4rem, 12vw, 5rem); }\n}\n\n/* Landscape hint bar for phones that don't support orientation lock */\n@media (max-width: 767px) and (orientation: portrait) {\n  .vp::after {\n    content: \"⟳  Rotate for best experience\";\n    position: absolute;\n    bottom: 7.5rem;\n    left: 50%;\n    transform: translateX(-50%);\n    font-size: 0.7rem;\n    font-weight: 600;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(255,255,255,0.45);\n    pointer-events: none;\n    white-space: nowrap;\n  }\n}\n\n/* ══ Reduced motion ════════════════════════════════════════ */\n@media (prefers-reduced-motion: reduce) {\n  .vp__back-btn,\n  .vp__centre-play { transition: none; }\n}\n\n/* ══ Gesture gate — URL-triggered open, needs one tap ═════ */\n.vp__gesture-gate {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  /* Subtle cinematic gradient so it feels intentional, not broken */\n  background: linear-gradient(\n    135deg,\n    rgba(27,27,27,0.92) 0%,\n    rgba(30,42,30,0.88) 100%\n  );\n  z-index: 10;\n}\n\n.vp__gesture-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.25rem;\n  text-align: center;\n  pointer-events: none; /* clicks pass through to the gate */\n}\n\n/* Pulsing play ring */\n.vp__gesture-ring {\n  width: clamp(5rem, 10vw, 7rem);\n  height: clamp(5rem, 10vw, 7rem);\n  border-radius: 50%;\n  background: rgba(255,255,255,0.1);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 2px solid rgba(255,255,255,0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: vp-pulse 2.4s ease-in-out infinite;\n}\n.vp__gesture-icon {\n  font-size: clamp(1.5rem, 3vw, 2.2rem);\n  color: #fff;\n  padding-left: 4px; /* optical centering */\n}\n\n@keyframes vp-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(255,255,255,0.25); }\n  50%       { box-shadow: 0 0 0 18px rgba(255,255,255,0); }\n}\n\n.vp__gesture-label {\n  font-size: clamp(0.78rem, 1.8vw, 1rem);\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.8);\n  margin: 0;\n}\n\n/* Back link — pointer-events re-enabled so it's clickable */\n.vp__gesture-back {\n  pointer-events: all;\n  background: none;\n  border: 1px solid rgba(255,255,255,0.2);\n  border-radius: 99px;\n  color: rgba(255,255,255,0.45);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  padding: 0.4rem 1rem;\n  cursor: pointer;\n  transition: all 0.18s;\n}\n.vp__gesture-back:hover {\n  border-color: rgba(255,255,255,0.45);\n  color: rgba(255,255,255,0.8);\n}\n\n@media (max-width: 767px) {\n  .vp__gesture-label { letter-spacing: 0.08em; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
